type AppliedPcfCatalogSections = {
  allTags: string;
  validationRuleCatalog?: string;
};

let appliedCatalogSections: AppliedPcfCatalogSections | null = null;

function isValidationRuleCatalog(serializedValidationMap: string): boolean {
  try {
    const parsed = JSON.parse(serializedValidationMap) as unknown;
    if (!Array.isArray(parsed)) {
      return false;
    }

    return parsed.some(
      (entry) =>
        entry !== null &&
        typeof entry === 'object' &&
        ('KeyWords' in entry || 'SKEY' in entry || 'ObjectType' in entry)
    );
  } catch {
    return false;
  }
}

export function captureAppliedPcfCatalogSections(
  settings: { allTags: string; validationMap: string }
): void {
  appliedCatalogSections = {
    allTags: settings.allTags,
    validationRuleCatalog: isValidationRuleCatalog(settings.validationMap)
      ? settings.validationMap
      : undefined,
  };
}

export function clearAppliedPcfCatalogSections(): void {
  appliedCatalogSections = null;
}

export function getAppliedAllTags(fallback: string): string {
  return appliedCatalogSections?.allTags ?? fallback;
}

export function getAppliedValidationMap(fallback: string): string {
  return appliedCatalogSections?.validationRuleCatalog ?? fallback;
}
